import { hasCapability, type User } from "../base";

export const opsAssignment = {
  read: (user: User) => hasCapability(user, "opsAssignment.read"),
  update: (user: User) => hasCapability(user, "opsAssignment.update"),
};
